export const CONTINENTS = [
  {
    id: 'EU',
    label: 'Europe',
  },
  {
    id: 'US',
    label: 'United States',
  },
] as const;

export const COUNTRIES = [
  {
    id: 'AD',
    label: 'Andorra',
    continentId: 'EU',
  },
  {
    id: 'AL',
    label: 'Albania',
    continentId: 'EU',
  },
  {
    id: 'AT',
    label: 'Austria',
    continentId: 'EU',
  },
  {
    id: 'BA',
    label: 'Bosnia and Herzegovina',
    continentId: 'EU',
  },
  {
    id: 'BE',
    label: 'Belgium',
    continentId: 'EU',
  },
  {
    id: 'BG',
    label: 'Bulgaria',
    continentId: 'EU',
  },
  {
    id: 'BY',
    label: 'Belarus',
    continentId: 'EU',
  },
  {
    id: 'CH',
    label: 'Switzerland',
    continentId: 'EU',
  },
  {
    id: 'CY',
    label: 'Cyprus',
    continentId: 'EU',
  },
  {
    id: 'CZ',
    label: 'Czech Republic',
    continentId: 'EU',
  },
  {
    id: 'DE',
    label: 'Germany',
    continentId: 'EU',
  },
  {
    id: 'DK',
    label: 'Denmark',
    continentId: 'EU',
  },
  {
    id: 'EE',
    label: 'Estonia',
    continentId: 'EU',
  },
  {
    id: 'ES',
    label: 'Spain',
    continentId: 'EU',
  },
  {
    id: 'FI',
    label: 'Finland',
    continentId: 'EU',
  },
  {
    id: 'FO',
    label: 'Faroe Islands',
    continentId: 'EU',
  },
  {
    id: 'FR',
    label: 'France',
    continentId: 'EU',
  },
  {
    id: 'GB',
    label: 'United Kingdom',
    continentId: 'EU',
  },
  {
    id: 'GG',
    label: 'Guernsey',
    continentId: 'EU',
  },
  {
    id: 'GI',
    label: 'Gibraltar',
    continentId: 'EU',
  },
  {
    id: 'GR',
    label: 'Greece',
    continentId: 'EU',
  },
  {
    id: 'HR',
    label: 'Croatia',
    continentId: 'EU',
  },
  {
    id: 'HU',
    label: 'Hungary',
    continentId: 'EU',
  },
  {
    id: 'IE',
    label: 'Ireland',
    continentId: 'EU',
  },
  {
    id: 'IM',
    label: 'Isle of Man',
    continentId: 'EU',
  },
  {
    id: 'IS',
    label: 'Iceland',
    continentId: 'EU',
  },
  {
    id: 'IT',
    label: 'Italy',
    continentId: 'EU',
  },
  {
    id: 'JE',
    label: 'Jersey',
    continentId: 'EU',
  },
  {
    id: 'LI',
    label: 'Liechtenstein',
    continentId: 'EU',
  },
  {
    id: 'LT',
    label: 'Lithuania',
    continentId: 'EU',
  },
  {
    id: 'LU',
    label: 'Luxembourg',
    continentId: 'EU',
  },
  {
    id: 'LV',
    label: 'Latvia',
    continentId: 'EU',
  },
  {
    id: 'MC',
    label: 'Monaco',
    continentId: 'EU',
  },
  {
    id: 'MD',
    label: 'Moldova',
    continentId: 'EU',
  },
  {
    id: 'ME',
    label: 'Montenegro',
    continentId: 'EU',
  },
  {
    id: 'MK',
    label: 'North Macedonia',
    continentId: 'EU',
  },
  {
    id: 'MT',
    label: 'Malta',
    continentId: 'EU',
  },
  {
    id: 'NL',
    label: 'Netherlands',
    continentId: 'EU',
  },
  {
    id: 'NO',
    label: 'Norway',
    continentId: 'EU',
  },
  {
    id: 'PL',
    label: 'Poland',
    continentId: 'EU',
  },
  {
    id: 'PT',
    label: 'Portugal',
    continentId: 'EU',
  },
  {
    id: 'RO',
    label: 'Romania',
    continentId: 'EU',
  },
  {
    id: 'RS',
    label: 'Serbia',
    continentId: 'EU',
  },
  {
    id: 'SE',
    label: 'Sweden',
    continentId: 'EU',
  },
  {
    id: 'SI',
    label: 'Slovenia',
    continentId: 'EU',
  },
  {
    id: 'SJ',
    label: 'Svalbard and Jan Mayen',
    continentId: 'EU',
  },
  {
    id: 'SK',
    label: 'Slovakia',
    continentId: 'EU',
  },
  {
    id: 'UA',
    label: 'Ukraine',
    continentId: 'EU',
  },
  {
    id: 'US',
    label: 'United States',
    continentId: 'US',
  },
  {
    id: 'VA',
    label: 'Vatican City',
    continentId: 'EU',
  },
  {
    id: 'XK',
    label: 'Kosovo',
    continentId: 'EU',
  },
] as const;

export const MARKET_ZONES = [
  {
    id: 'AD',
    countryId: 'AD',
    continentId: 'EU',
    label: 'Andorra',
  },
  {
    id: 'AL',
    countryId: 'AL',
    continentId: 'EU',
    label: 'Albania',
  },
  {
    id: 'AT',
    countryId: 'AT',
    continentId: 'EU',
    label: 'Austria',
  },
  {
    id: 'BA',
    countryId: 'BA',
    continentId: 'EU',
    label: 'Bosnia and Herzegovina',
  },
  {
    id: 'BE',
    countryId: 'BE',
    continentId: 'EU',
    label: 'Belgium',
  },
  {
    id: 'BG',
    countryId: 'BG',
    continentId: 'EU',
    label: 'Bulgaria',
  },
  {
    id: 'BY',
    countryId: 'BY',
    continentId: 'EU',
    label: 'Belarus',
  },
  {
    id: 'CH',
    countryId: 'CH',
    continentId: 'EU',
    label: 'Switzerland',
  },
  {
    id: 'CY',
    countryId: 'CY',
    continentId: 'EU',
    label: 'Cyprus',
  },
  {
    id: 'CZ',
    countryId: 'CZ',
    continentId: 'EU',
    label: 'Czech Republic',
  },
  {
    id: 'DE',
    countryId: 'DE',
    continentId: 'EU',
    label: 'Germany',
  },
  {
    id: 'DK-BHM',
    countryId: 'DK',
    continentId: 'EU',
    label: 'Denmark (Bornholm)',
  },
  {
    id: 'DK-DK1',
    countryId: 'DK',
    continentId: 'EU',
    label: 'Denmark (DK1)',
  },
  {
    id: 'DK-DK2',
    countryId: 'DK',
    continentId: 'EU',
    label: 'Denmark (DK2)',
  },
  {
    id: 'EE',
    countryId: 'EE',
    continentId: 'EU',
    label: 'Estonia',
  },
  {
    id: 'ES',
    countryId: 'ES',
    continentId: 'EU',
    label: 'Spain',
  },
  {
    id: 'ES-CN-FV',
    countryId: 'ES',
    continentId: 'EU',
    label: 'Spain (Canary Islands - Fuerteventura)',
  },
  {
    id: 'ES-CN-GC',
    countryId: 'ES',
    continentId: 'EU',
    label: 'Spain (Canary Islands - Gran Canaria)',
  },
  {
    id: 'ES-CN-HI',
    countryId: 'ES',
    continentId: 'EU',
    label: 'Spain (Canary Islands - El Hierro)',
  },
  {
    id: 'ES-CN-IG',
    countryId: 'ES',
    continentId: 'EU',
    label: 'Spain (Canary Islands - La Gomera)',
  },
  {
    id: 'ES-CN-LP',
    countryId: 'ES',
    continentId: 'EU',
    label: 'Spain (Canary Islands - La Palma)',
  },
  {
    id: 'ES-CN-LZ',
    countryId: 'ES',
    continentId: 'EU',
    label: 'Spain (Canary Islands - Lanzarote)',
  },
  {
    id: 'ES-CN-TE',
    countryId: 'ES',
    continentId: 'EU',
    label: 'Spain (Canary Islands - Tenerife)',
  },
  {
    id: 'ES-IB-FO',
    countryId: 'ES',
    continentId: 'EU',
    label: 'Spain (Balearic Islands - Formentera)',
  },
  {
    id: 'ES-IB-IZ',
    countryId: 'ES',
    continentId: 'EU',
    label: 'Spain (Balearic Islands - Ibiza)',
  },
  {
    id: 'ES-IB-MA',
    countryId: 'ES',
    continentId: 'EU',
    label: 'Spain (Balearic Islands - Mallorca)',
  },
  {
    id: 'ES-IB-ME',
    countryId: 'ES',
    continentId: 'EU',
    label: 'Spain (Balearic Islands - Menorca)',
  },
  {
    id: 'FI',
    countryId: 'FI',
    continentId: 'EU',
    label: 'Finland',
  },
  {
    id: 'FO-MI',
    countryId: 'FO',
    continentId: 'EU',
    label: 'Faroe Islands (Main)',
  },
  {
    id: 'FO-SI',
    countryId: 'FO',
    continentId: 'EU',
    label: 'Faroe Islands (Suðuroy)',
  },
  {
    id: 'FR',
    countryId: 'FR',
    continentId: 'EU',
    label: 'France',
  },
  {
    id: 'FR-COR',
    countryId: 'FR',
    continentId: 'EU',
    label: 'France (Corsica)',
  },
  {
    id: 'GB',
    countryId: 'GB',
    continentId: 'EU',
    label: 'Great Britain',
  },
  {
    id: 'GB-NIR',
    countryId: 'GB',
    continentId: 'EU',
    label: 'Northern Ireland',
  },
  {
    id: 'GB-ORK',
    countryId: 'GB',
    continentId: 'EU',
    label: 'Orkney Islands',
  },
  {
    id: 'GB-ZET',
    countryId: 'GB',
    continentId: 'EU',
    label: 'Shetland Islands',
  },
  {
    id: 'GG',
    countryId: 'GG',
    continentId: 'EU',
    label: 'Guernsey',
  },
  {
    id: 'GR',
    countryId: 'GR',
    continentId: 'EU',
    label: 'Greece',
  },
  {
    id: 'HR',
    countryId: 'HR',
    continentId: 'EU',
    label: 'Croatia',
  },
  {
    id: 'HU',
    countryId: 'HU',
    continentId: 'EU',
    label: 'Hungary',
  },
  {
    id: 'IE',
    countryId: 'IE',
    continentId: 'EU',
    label: 'Ireland',
  },
  {
    id: 'IM',
    countryId: 'IM',
    continentId: 'EU',
    label: 'Isle of Man',
  },
  {
    id: 'IS',
    countryId: 'IS',
    continentId: 'EU',
    label: 'Iceland',
  },
  {
    id: 'IT-CNO',
    countryId: 'IT',
    continentId: 'EU',
    label: 'Italy (Central North)',
  },
  {
    id: 'IT-CSO',
    countryId: 'IT',
    continentId: 'EU',
    label: 'Italy (Central South)',
  },
  {
    id: 'IT-NO',
    countryId: 'IT',
    continentId: 'EU',
    label: 'Italy (North)',
  },
  {
    id: 'IT-SAR',
    countryId: 'IT',
    continentId: 'EU',
    label: 'Italy (Sardinia)',
  },
  {
    id: 'IT-SIC',
    countryId: 'IT',
    continentId: 'EU',
    label: 'Italy (Sicily)',
  },
  {
    id: 'IT-SO',
    countryId: 'IT',
    continentId: 'EU',
    label: 'Italy (South)',
  },
  {
    id: 'IT-CALA',
    countryId: 'IT',
    continentId: 'EU',
    label: 'Italy (Calabria)',
  },
  {
    id: 'JE',
    countryId: 'JE',
    continentId: 'EU',
    label: 'Jersey',
  },
  {
    id: 'LI',
    countryId: 'LI',
    continentId: 'EU',
    label: 'Liechtenstein',
  },
  {
    id: 'LT',
    countryId: 'LT',
    continentId: 'EU',
    label: 'Lithuania',
  },
  {
    id: 'LU',
    countryId: 'LU',
    continentId: 'EU',
    label: 'Luxembourg',
  },
  {
    id: 'LV',
    countryId: 'LV',
    continentId: 'EU',
    label: 'Latvia',
  },
  {
    id: 'MD',
    countryId: 'MD',
    continentId: 'EU',
    label: 'Moldova',
  },
  {
    id: 'ME',
    countryId: 'ME',
    continentId: 'EU',
    label: 'Montenegro',
  },
  {
    id: 'MK',
    countryId: 'MK',
    continentId: 'EU',
    label: 'North Macedonia',
  },
  {
    id: 'MT',
    countryId: 'MT',
    continentId: 'EU',
    label: 'Malta',
  },
  {
    id: 'NL',
    countryId: 'NL',
    continentId: 'EU',
    label: 'Netherlands',
  },
  {
    id: 'NO-NO1',
    countryId: 'NO',
    continentId: 'EU',
    label: 'Norway (NO1)',
  },
  {
    id: 'NO-NO2',
    countryId: 'NO',
    continentId: 'EU',
    label: 'Norway (NO2)',
  },
  {
    id: 'NO-NO3',
    countryId: 'NO',
    continentId: 'EU',
    label: 'Norway (NO3)',
  },
  {
    id: 'NO-NO4',
    countryId: 'NO',
    continentId: 'EU',
    label: 'Norway (NO4)',
  },
  {
    id: 'NO-NO5',
    countryId: 'NO',
    continentId: 'EU',
    label: 'Norway (NO5)',
  },
  {
    id: 'PL',
    countryId: 'PL',
    continentId: 'EU',
    label: 'Poland',
  },
  {
    id: 'PT',
    countryId: 'PT',
    continentId: 'EU',
    label: 'Portugal',
  },
  {
    id: 'PT-AC',
    countryId: 'PT',
    continentId: 'EU',
    label: 'Portugal (Azores)',
  },
  {
    id: 'PT-MA',
    countryId: 'PT',
    continentId: 'EU',
    label: 'Portugal (Madeira)',
  },
  {
    id: 'RO',
    countryId: 'RO',
    continentId: 'EU',
    label: 'Romania',
  },
  {
    id: 'RS',
    countryId: 'RS',
    continentId: 'EU',
    label: 'Serbia',
  },
  {
    id: 'SE-SE1',
    countryId: 'SE',
    continentId: 'EU',
    label: 'Sweden (SE1)',
  },
  {
    id: 'SE-SE2',
    countryId: 'SE',
    continentId: 'EU',
    label: 'Sweden (SE2)',
  },
  {
    id: 'SE-SE3',
    countryId: 'SE',
    continentId: 'EU',
    label: 'Sweden (SE3)',
  },
  {
    id: 'SE-SE4',
    countryId: 'SE',
    continentId: 'EU',
    label: 'Sweden (SE4)',
  },
  {
    id: 'SI',
    countryId: 'SI',
    continentId: 'EU',
    label: 'Slovenia',
  },
  {
    id: 'SJ',
    countryId: 'SJ',
    continentId: 'EU',
    label: 'Svalbard and Jan Mayen',
  },
  {
    id: 'SK',
    countryId: 'SK',
    continentId: 'EU',
    label: 'Slovakia',
  },
  {
    id: 'UA',
    countryId: 'UA',
    continentId: 'EU',
    label: 'Ukraine',
  },
  {
    id: 'UA-CR',
    countryId: 'UA',
    continentId: 'EU',
    label: 'Ukraine (Crimea)',
  },
  {
    id: 'US-AK',
    countryId: 'US',
    continentId: 'US',
    label: 'Alaska',
  },
  {
    id: 'US-AK-SEAPA',
    countryId: 'US',
    continentId: 'US',
    label: 'Alaska (Southeast)',
  },
  {
    id: 'US-CAL-BANC',
    countryId: 'US',
    continentId: 'US',
    label: 'California (BANC)',
  },
  {
    id: 'US-CAL-CISO',
    countryId: 'US',
    continentId: 'US',
    label: 'California ISO',
  },
  {
    id: 'US-CAL-IID',
    countryId: 'US',
    continentId: 'US',
    label: 'California (Imperial Irrigation District)',
  },
  {
    id: 'US-CAL-LDWP',
    countryId: 'US',
    continentId: 'US',
    label: 'Los Angeles Department of Water and Power',
  },
  {
    id: 'US-CAL-TIDC',
    countryId: 'US',
    continentId: 'US',
    label: 'California (Turlock Irrigation District)',
  },
  {
    id: 'US-CAR-CPLE',
    countryId: 'US',
    continentId: 'US',
    label: 'Carolina (Eastern)',
  },
  {
    id: 'US-CAR-CPLW',
    countryId: 'US',
    continentId: 'US',
    label: 'Carolina (Western)',
  },
  {
    id: 'US-CAR-DUK',
    countryId: 'US',
    continentId: 'US',
    label: 'Duke Energy Carolinas',
  },
  {
    id: 'US-CAR-SC',
    countryId: 'US',
    continentId: 'US',
    label: 'South Carolina',
  },
  {
    id: 'US-CAR-SCEG',
    countryId: 'US',
    continentId: 'US',
    label: 'South Carolina Electric & Gas',
  },
  {
    id: 'US-CENT-SPA',
    countryId: 'US',
    continentId: 'US',
    label: 'Southwest Power Pool Area',
  },
  {
    id: 'US-CENT-SWPP',
    countryId: 'US',
    continentId: 'US',
    label: 'Southwest Power Pool',
  },
  {
    id: 'US-FLA-FMPP',
    countryId: 'US',
    continentId: 'US',
    label: 'Florida Municipal Power Pool',
  },
  {
    id: 'US-FLA-FPC',
    countryId: 'US',
    continentId: 'US',
    label: 'Florida Power Corporation',
  },
  {
    id: 'US-FLA-FPL',
    countryId: 'US',
    continentId: 'US',
    label: 'Florida Power & Light',
  },
  {
    id: 'US-FLA-GVL',
    countryId: 'US',
    continentId: 'US',
    label: 'Gainesville Regional Utilities',
  },
  {
    id: 'US-FLA-HST',
    countryId: 'US',
    continentId: 'US',
    label: 'City of Homestead',
  },
  {
    id: 'US-FLA-JEA',
    countryId: 'US',
    continentId: 'US',
    label: 'Jacksonville Electric Authority',
  },
  {
    id: 'US-FLA-SEC',
    countryId: 'US',
    continentId: 'US',
    label: 'Seminole Electric Cooperative',
  },
  // Additional US zones from ClickHouse data
  {
    id: 'US-FLA-TAL',
    countryId: 'US',
    continentId: 'US',
    label: 'City of Tallahassee',
  },
  {
    id: 'US-FLA-TEC',
    countryId: 'US',
    continentId: 'US',
    label: 'Tampa Electric Company',
  },
  {
    id: 'US-HI',
    countryId: 'US',
    continentId: 'US',
    label: 'Hawaii',
  },
  {
    id: 'US-MIDA-PJM',
    countryId: 'US',
    continentId: 'US',
    label: 'PJM Interconnection',
  },
  {
    id: 'US-MIDW-AECI',
    countryId: 'US',
    continentId: 'US',
    label: 'Associated Electric Cooperative',
  },
  {
    id: 'US-MIDW-LGEE',
    countryId: 'US',
    continentId: 'US',
    label: 'Louisville Gas and Electric',
  },
  {
    id: 'US-MIDW-MISO',
    countryId: 'US',
    continentId: 'US',
    label: 'Midcontinent ISO',
  },
  {
    id: 'US-NE-ISNE',
    countryId: 'US',
    continentId: 'US',
    label: 'New England ISO',
  },
  {
    id: 'US-NW-AVA',
    countryId: 'US',
    continentId: 'US',
    label: 'Avista Corporation',
  },
  {
    id: 'US-NW-BPAT',
    countryId: 'US',
    continentId: 'US',
    label: 'Bonneville Power Administration',
  },
  {
    id: 'US-NW-CHPD',
    countryId: 'US',
    continentId: 'US',
    label: 'Public Utility District No. 1 of Chelan County',
  },
  {
    id: 'US-NW-DOPD',
    countryId: 'US',
    continentId: 'US',
    label: 'PUD No. 1 of Douglas County',
  },
  {
    id: 'US-NW-GCPD',
    countryId: 'US',
    continentId: 'US',
    label: 'Public Utility District No. 2 of Grant County',
  },
  {
    id: 'US-NW-IPCO',
    countryId: 'US',
    continentId: 'US',
    label: 'Idaho Power Company',
  },
  {
    id: 'US-NW-NEVP',
    countryId: 'US',
    continentId: 'US',
    label: 'NV Energy',
  },
  {
    id: 'US-NW-NWMT',
    countryId: 'US',
    continentId: 'US',
    label: 'NorthWestern Energy',
  },
  {
    id: 'US-NW-PACE',
    countryId: 'US',
    continentId: 'US',
    label: 'PacifiCorp East',
  },
  {
    id: 'US-NW-PACW',
    countryId: 'US',
    continentId: 'US',
    label: 'PacifiCorp West',
  },
  {
    id: 'US-NW-PGE',
    countryId: 'US',
    continentId: 'US',
    label: 'Portland General Electric',
  },
  {
    id: 'US-NW-PSCO',
    countryId: 'US',
    continentId: 'US',
    label: 'Public Service Company of Colorado',
  },
  {
    id: 'US-NW-PSEI',
    countryId: 'US',
    continentId: 'US',
    label: 'Puget Sound Energy',
  },
  {
    id: 'US-NW-SCL',
    countryId: 'US',
    continentId: 'US',
    label: 'Seattle City Light',
  },
  {
    id: 'US-NW-TPWR',
    countryId: 'US',
    continentId: 'US',
    label: 'Tacoma Power',
  },
  {
    id: 'US-NW-WACM',
    countryId: 'US',
    continentId: 'US',
    label: 'Western Area Power Administration Colorado Missouri',
  },
  {
    id: 'US-NW-WAUW',
    countryId: 'US',
    continentId: 'US',
    label: 'Western Area Power Administration Upper Great Plains West',
  },
  {
    id: 'US-NY-NYIS',
    countryId: 'US',
    continentId: 'US',
    label: 'New York ISO',
  },
  {
    id: 'US-SE-SOCO',
    countryId: 'US',
    continentId: 'US',
    label: 'Southern Company',
  },
  {
    id: 'US-SW-AZPS',
    countryId: 'US',
    continentId: 'US',
    label: 'Arizona Public Service',
  },
  {
    id: 'US-SW-EPE',
    countryId: 'US',
    continentId: 'US',
    label: 'El Paso Electric',
  },
  {
    id: 'US-SW-PNM',
    countryId: 'US',
    continentId: 'US',
    label: 'Public Service Company of New Mexico',
  },
  {
    id: 'US-SW-SRP',
    countryId: 'US',
    continentId: 'US',
    label: 'Salt River Project',
  },
  {
    id: 'US-SW-TEPC',
    countryId: 'US',
    continentId: 'US',
    label: 'Tucson Electric Power',
  },
  {
    id: 'US-SW-WALC',
    countryId: 'US',
    continentId: 'US',
    label: 'Western Area Power Administration Lower Colorado',
  },
  {
    id: 'US-TEN-TVA',
    countryId: 'US',
    continentId: 'US',
    label: 'Tennessee Valley Authority',
  },
  {
    id: 'US-TEX-ERCO',
    countryId: 'US',
    continentId: 'US',
    label: 'ERCOT Texas',
  },
] as const;

// Mapping from TSO zone IDs to Market zone IDs for GeoJSON file loading
// This ensures we can use the existing TSO GeoJSON files with the unified market zone system
export const TSO_TO_MARKET_ZONE_MAPPING: Record<string, MarketZoneId> = {
  // Simple mappings (TSO zone ID = Market zone ID)
  AT: 'AT',
  BE: 'BE',
  BG: 'BG',
  CH: 'CH',
  CZ: 'CZ',
  EE: 'EE',
  ES: 'ES',
  FI: 'FI',
  FR: 'FR',
  GR: 'GR',
  HR: 'HR',
  HU: 'HU',
  LT: 'LT',
  LV: 'LV',
  NL: 'NL',
  PL: 'PL',
  PT: 'PT',
  RO: 'RO',
  RS: 'RS',
  SI: 'SI',
  SK: 'SK',
  UA: 'UA',
  'UA-CR': 'UA-CR',

  // Denmark zones
  DK_1: 'DK-DK1',
  DK_2: 'DK-DK2',

  // Germany-Luxembourg (use Germany for the combined zone)
  DE_LU: 'DE',

  // Italy zones
  IT_NORD: 'IT-NO',
  IT_CNOR: 'IT-CNO',
  IT_CSUD: 'IT-CSO',
  IT_SUD: 'IT-SO',
  IT_SICI: 'IT-SIC',
  IT_SARD: 'IT-SAR',
  IT_CALA: 'IT-CALA',

  // Norway zones
  NO_1: 'NO-NO1',
  NO_2: 'NO-NO2',
  NO_3: 'NO-NO3',
  NO_4: 'NO-NO4',
  NO_5: 'NO-NO5',

  // Sweden zones
  SE_1: 'SE-SE1',
  SE_2: 'SE-SE2',
  SE_3: 'SE-SE3',
  SE_4: 'SE-SE4',

  // UK and Ireland zones (using ElectricityMaps GeoJSON files)
  GB: 'GB',
  'GB-NIR': 'GB-NIR',
  'GB-ORK': 'GB-ORK',
  'GB-ZET': 'GB-ZET',
  IE: 'IE',

  // US zones (using underscore convention for TSO filenames)
  // Backend will filter zones based on actual data availability
  US_AK: 'US-AK',
  US_AK_SEAPA: 'US-AK-SEAPA',
  US_CAL_BANC: 'US-CAL-BANC',
  US_CAL_CISO: 'US-CAL-CISO',
  US_CAL_IID: 'US-CAL-IID',
  US_CAL_LDWP: 'US-CAL-LDWP',
  US_CAL_TIDC: 'US-CAL-TIDC',
  US_CAR_CPLE: 'US-CAR-CPLE',
  US_CAR_CPLW: 'US-CAR-CPLW',
  US_CAR_DUK: 'US-CAR-DUK',
  US_CAR_SC: 'US-CAR-SC',
  US_CAR_SCEG: 'US-CAR-SCEG',
  US_CENT_SPA: 'US-CENT-SPA',
  US_CENT_SWPP: 'US-CENT-SWPP',
  US_FLA_FMPP: 'US-FLA-FMPP',
  US_FLA_FPC: 'US-FLA-FPC',
  US_FLA_FPL: 'US-FLA-FPL',
  US_FLA_GVL: 'US-FLA-GVL',
  US_FLA_HST: 'US-FLA-HST',
  US_FLA_JEA: 'US-FLA-JEA',
  US_FLA_SEC: 'US-FLA-SEC',
  US_FLA_TAL: 'US-FLA-TAL',
  US_FLA_TEC: 'US-FLA-TEC',
  US_HI: 'US-HI',
  US_MIDA_PJM: 'US-MIDA-PJM',
  US_MIDW_AECI: 'US-MIDW-AECI',
  US_MIDW_LGEE: 'US-MIDW-LGEE',
  US_MIDW_MISO: 'US-MIDW-MISO',
  US_NE_ISNE: 'US-NE-ISNE',
  US_NW_AVA: 'US-NW-AVA',
  US_NW_BPAT: 'US-NW-BPAT',
  US_NW_CHPD: 'US-NW-CHPD',
  US_NW_DOPD: 'US-NW-DOPD',
  US_NW_GCPD: 'US-NW-GCPD',
  US_NW_IPCO: 'US-NW-IPCO',
  US_NW_NEVP: 'US-NW-NEVP',
  US_NW_NWMT: 'US-NW-NWMT',
  US_NW_PACE: 'US-NW-PACE',
  US_NW_PACW: 'US-NW-PACW',
  US_NW_PGE: 'US-NW-PGE',
  US_NW_PSCO: 'US-NW-PSCO',
  US_NW_PSEI: 'US-NW-PSEI',
  US_NW_SCL: 'US-NW-SCL',
  US_NW_TPWR: 'US-NW-TPWR',
  US_NW_WACM: 'US-NW-WACM',
  US_NW_WAUW: 'US-NW-WAUW',
  US_NY_NYIS: 'US-NY-NYIS',
  US_SE_SOCO: 'US-SE-SOCO',
  US_SW_AZPS: 'US-SW-AZPS',
  US_SW_EPE: 'US-SW-EPE',
  US_SW_PNM: 'US-SW-PNM',
  US_SW_SRP: 'US-SW-SRP',
  US_SW_TEPC: 'US-SW-TEPC',
  US_SW_WALC: 'US-SW-WALC',
  US_TEN_TVA: 'US-TEN-TVA',
  US_TEX_ERCO: 'US-TEX-ERCO',
} as const;

// Get all TSO zones that have GeoJSON files available
export const TSO_ZONES_WITH_GEOJSON = Object.keys(TSO_TO_MARKET_ZONE_MAPPING);

// Get the corresponding market zones that have TSO GeoJSON data
export const MARKET_ZONES_WITH_TSO_DATA = MARKET_ZONES.filter((zone) =>
  Object.values(TSO_TO_MARKET_ZONE_MAPPING).includes(zone.id as any),
);

export type Continent = (typeof CONTINENTS)[number];
export type ContinentId = Continent['id'];

export type MarketZone = (typeof MARKET_ZONES)[number];
export type MarketZoneId = MarketZone['id'];
